if (!customElements.get('localization-form')) {
  customElements.define('localization-form', class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.mql = window.matchMedia('(min-width: 750px)');
      this.header = document.querySelector('.header-wrapper');
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button.localization-form__select'),
        panel: this.querySelector('.disclosure__list-wrapper'),
        search: this.querySelector('input[name="country_filter"]'),
        closeButton: this.querySelector('.country-selector__close-button'),
        resetButton: this.querySelector('.country-filter__reset-button'),
        searchIcon: this.querySelector('.country-filter__search-icon'),
        liveRegion: this.querySelector('[data-country-search-results-live-region]'),
        overlay: this.querySelector('.country-selector__overlay'),
      };
      this.items = Array.from(this.querySelectorAll('a[data-value]'));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
      this.addEventListener('focusout', this.closeSelector.bind(this));
      this.elements.button.addEventListener('click', this.openSelector.bind(this));

      if (this.elements.search) {
        this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
        this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
        this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
        this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
      }
      if (this.elements.closeButton) {
        this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
      }
      if (this.elements.overlay) {
        this.elements.overlay.addEventListener('click', this.hidePanel.bind(this));
      }
      if (this.elements.resetButton) {
        this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
        this.elements.resetButton.addEventListener('mousedown', (event) => event.preventDefault());
      }

      this.items.forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
      if (this.elements.search) {
        this.elements.search.value = '';
        this.filterCountries();
        this.elements.search.setAttribute('aria-activedescendant', '');
      }
      document.body.classList.remove('overflow-hidden-mobile');
      document.querySelector('.menu-drawer')?.classList.remove('country-selector-open');
      if (this.header) this.header.preventHide = false;
    }

    onContainerKeyDown(event) {
      const focusableItems = this.items.filter((item) => !item.parentElement.classList.contains('hidden'));
      let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
      let itemToFocus;

      if (!focusableItems.length) return;

      switch (event.code.toUpperCase()) {
        case 'ARROWUP':
          event.preventDefault();
          itemToFocus =
            focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
          itemToFocus.focus();
          break;
        case 'ARROWDOWN':
          event.preventDefault();
          itemToFocus =
            focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
          itemToFocus.focus();
          break;
      }

      if (!this.elements.search) return;

      setTimeout(() => {
        focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        if (focusedItemIndex > -1) {
          this.elements.search.setAttribute('aria-activedescendant', focusableItems[focusedItemIndex].id);
        } else {
          this.elements.search.setAttribute('aria-activedescendant', '');
        }
      });
    }

    onContainerKeyUp(event) {
      switch (event.code.toUpperCase()) {
        case 'ESCAPE':
          event.preventDefault();
          if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
          this.hidePanel();
          event.stopPropagation();
          this.elements.button.focus();
          break;
        case 'SPACE':
          if (event.target !== this.elements.button) return;
          event.preventDefault();
          if (this.elements.button.getAttribute('aria-expanded') == 'true') return;
          this.openSelector();
          break;
      }
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      const selectedItem = event.currentTarget;
      this.elements.input.value = selectedItem.dataset.value;
      this.setActiveItem(selectedItem);
      this.updateButtonLabel(selectedItem);
      if (form) form.submit();
    }

    openSelector() {
      if (this.elements.button.getAttribute('aria-expanded') === 'true') {
        this.hidePanel();
        return;
      }

      this.elements.button.focus();
      this.elements.panel.removeAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', 'true');

      if (!document.body.classList.contains('overflow-hidden-tablet')) {
        document.body.classList.add('overflow-hidden-mobile');
      }
      if (this.elements.search && this.mql.matches) {
        this.elements.search.focus();
      }
      if (this.hasAttribute('data-prevent-hide') && this.header) {
        this.header.preventHide = true;
      }
      document.querySelector('.menu-drawer')?.classList.add('country-selector-open');
    }

    closeSelector(event) {
      if (!this.contains(event.relatedTarget)) {
        this.hidePanel();
      }
    }

    normalizeString(str) {
      return str
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .toLowerCase();
    }

    filterCountries() {
      const searchValue = this.normalizeString(this.elements.search.value);
      const popularCountries = this.querySelector('.popular-countries');
      let visibleCountries = 0;

      this.elements.resetButton?.classList.toggle('hidden', !searchValue);

      if (popularCountries) {
        popularCountries.classList.toggle('hidden', !!searchValue);
      }

      this.items.forEach((item) => {
        const countryName = this.normalizeString(item.querySelector('.country')?.textContent || '');
        const matches = countryName.indexOf(searchValue) > -1;

        if (matches) {
          item.parentElement.classList.remove('hidden');
        } else {
          item.parentElement.classList.add('hidden');
        }

        if (matches && item.closest('.countries')) {
          visibleCountries += 1;
        }
      });

      if (this.elements.liveRegion && window.accessibilityStrings?.countrySelectorSearchCount) {
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace(
          '[count]',
          visibleCountries
        );
      }

      this.querySelector('.country-selector')?.scrollTo(0, 0);
      this.querySelector('.country-selector__list')?.scrollTo(0, 0);
    }

    resetFilter(event) {
      event.preventDefault();
      event.stopPropagation();
      if (!this.elements.search) return;
      this.elements.search.value = '';
      this.filterCountries();
      this.elements.search.focus();
    }

    onSearchFocus() {
      this.elements.searchIcon?.classList.add('country-filter__search-icon--hidden');
    }

    onSearchBlur() {
      if (!this.elements.search.value) {
        this.elements.searchIcon?.classList.remove('country-filter__search-icon--hidden');
      }
    }

    onSearchKeyDown(event) {
      if (event.code.toUpperCase() === 'ENTER') {
        event.preventDefault();
      }
    }

    setActiveItem(selectedItem) {
      this.items.forEach((item) => {
        const isActive = item === selectedItem;
        item.classList.toggle('disclosure__link--active', isActive);

        if (isActive) {
          item.setAttribute('aria-current', 'true');
        } else {
          item.removeAttribute('aria-current');
        }

        const checkmarkContainer = item.querySelector('.icon-checkmark')?.parentElement;
        if (checkmarkContainer) {
          checkmarkContainer.classList.toggle('visibility-hidden', !isActive);
        }
      });
    }

    updateButtonLabel(selectedItem) {
      const buttonLabel = this.elements.button?.querySelector('span');
      if (!buttonLabel) return;

      if (selectedItem.querySelector('.country')) {
        const currency = selectedItem.querySelector('.localization-form__currency')?.textContent.replace(/\s+/g, ' ').trim();
        const country = selectedItem.querySelector('.country')?.textContent.replace(/\s+/g, ' ').trim();
        buttonLabel.textContent = currency ? `${country} | ${currency}` : country;
        return;
      }

      buttonLabel.textContent = selectedItem.textContent.replace(/\s+/g, ' ').trim();
    }
  });
}
